import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=0bcb448e&scoped=true"
import script from "./InfoModal.vue?vue&type=script&lang=js"
export * from "./InfoModal.vue?vue&type=script&lang=js"
import style0 from "./InfoModal.vue?vue&type=style&index=0&id=0bcb448e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bcb448e",
  null
  
)

export default component.exports